<template>
  <div class="no-data">
    <div class="no-data-cnt">{{$t('components.widgetHomepage.nav.noData')}}</div>
  </div>
</template>

<script>
// 暂无数据页面
export default {
  name: 'no-data',
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.no-data {
  width: 100%;
  height: 100%;
  position: relative;
  .no-data-cnt {
    position: absolute;
    height: 12px;
    color: #999;
    line-height: 12px;
    font-size: 12px;
    width: 50px;
    left: 50%;
    top: 50%;
    margin-top: -6px;
    margin-left: -25px;
  }
}
</style>
